/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  FulfillStockOrderParams,
  GetStockOrderBulkProductsParams,
  GetStockOrdersParams,
  HTTPValidationError,
  PageStockOrderBulkProductRead,
  PageStockOrderManyRead,
  StockOrder,
  StockOrderContentsCreate,
  StockOrderCreate,
  StockOrderRead,
  UpdateStockOrderChargedDateParams,
  UpdateStockOrderTargetFulfillByParams,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create a new batch order.
 * @summary Create Stock Order
 */
export const createStockOrder = (
  stockOrderCreate: StockOrderCreate,
  signal?: AbortSignal,
) => {
  return customInstance<StockOrder>({
    url: `/api/stock_order/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: stockOrderCreate,
    signal,
  });
};

export const getCreateStockOrderMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStockOrder>>,
    TError,
    { data: StockOrderCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStockOrder>>,
  TError,
  { data: StockOrderCreate },
  TContext
> => {
  const mutationKey = ["createStockOrder"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStockOrder>>,
    { data: StockOrderCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createStockOrder(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStockOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStockOrder>>
>;
export type CreateStockOrderMutationBody = StockOrderCreate;
export type CreateStockOrderMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Stock Order
 */
export const useCreateStockOrder = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createStockOrder>>,
      TError,
      { data: StockOrderCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createStockOrder>>,
  TError,
  { data: StockOrderCreate },
  TContext
> => {
  const mutationOptions = getCreateStockOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many warehouse orders.

Results are paginated.
 * @summary Get Stock Orders
 */
export const getStockOrders = (
  params?: GetStockOrdersParams,
  signal?: AbortSignal,
) => {
  return customInstance<PageStockOrderManyRead>({
    url: `/api/stock_order/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetStockOrdersQueryKey = (params?: GetStockOrdersParams) => {
  return ["api", "stock_order", ...(params ? [params] : [])] as const;
};

export const getGetStockOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetStockOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStockOrders>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStockOrdersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockOrders>>> = ({
    signal,
  }) => getStockOrders(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockOrders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStockOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockOrders>>
>;
export type GetStockOrdersQueryError = ErrorType<void | HTTPValidationError>;

export function useGetStockOrders<
  TData = Awaited<ReturnType<typeof getStockOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetStockOrdersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStockOrders>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockOrders>>,
          TError,
          Awaited<ReturnType<typeof getStockOrders>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStockOrders<
  TData = Awaited<ReturnType<typeof getStockOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetStockOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStockOrders>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockOrders>>,
          TError,
          Awaited<ReturnType<typeof getStockOrders>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStockOrders<
  TData = Awaited<ReturnType<typeof getStockOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetStockOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStockOrders>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Stock Orders
 */

export function useGetStockOrders<
  TData = Awaited<ReturnType<typeof getStockOrders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetStockOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStockOrders>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetStockOrdersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update the contents of a warehouse order.
 * @summary Create Stock Order Contents
 */
export const createStockOrderContents = (
  stockOrderId: string,
  stockOrderContentsCreate: StockOrderContentsCreate,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/stock_order/${stockOrderId}/contents`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: stockOrderContentsCreate,
    signal,
  });
};

export const getCreateStockOrderContentsMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStockOrderContents>>,
    TError,
    { stockOrderId: string; data: StockOrderContentsCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStockOrderContents>>,
  TError,
  { stockOrderId: string; data: StockOrderContentsCreate },
  TContext
> => {
  const mutationKey = ["createStockOrderContents"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStockOrderContents>>,
    { stockOrderId: string; data: StockOrderContentsCreate }
  > = (props) => {
    const { stockOrderId, data } = props ?? {};

    return createStockOrderContents(stockOrderId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStockOrderContentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStockOrderContents>>
>;
export type CreateStockOrderContentsMutationBody = StockOrderContentsCreate;
export type CreateStockOrderContentsMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Stock Order Contents
 */
export const useCreateStockOrderContents = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createStockOrderContents>>,
      TError,
      { stockOrderId: string; data: StockOrderContentsCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createStockOrderContents>>,
  TError,
  { stockOrderId: string; data: StockOrderContentsCreate },
  TContext
> => {
  const mutationOptions = getCreateStockOrderContentsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many bulk_products.

Results are paginated.
 * @summary Get Stock Order Bulk Products
 */
export const getStockOrderBulkProducts = (
  params?: GetStockOrderBulkProductsParams,
  signal?: AbortSignal,
) => {
  return customInstance<PageStockOrderBulkProductRead>({
    url: `/api/stock_order/bulk-products`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetStockOrderBulkProductsQueryKey = (
  params?: GetStockOrderBulkProductsParams,
) => {
  return [
    "api",
    "stock_order",
    "bulk-products",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetStockOrderBulkProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockOrderBulkProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetStockOrderBulkProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStockOrderBulkProducts>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStockOrderBulkProductsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStockOrderBulkProducts>>
  > = ({ signal }) => getStockOrderBulkProducts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockOrderBulkProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStockOrderBulkProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockOrderBulkProducts>>
>;
export type GetStockOrderBulkProductsQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetStockOrderBulkProducts<
  TData = Awaited<ReturnType<typeof getStockOrderBulkProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetStockOrderBulkProductsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStockOrderBulkProducts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockOrderBulkProducts>>,
          TError,
          Awaited<ReturnType<typeof getStockOrderBulkProducts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStockOrderBulkProducts<
  TData = Awaited<ReturnType<typeof getStockOrderBulkProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetStockOrderBulkProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStockOrderBulkProducts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockOrderBulkProducts>>,
          TError,
          Awaited<ReturnType<typeof getStockOrderBulkProducts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStockOrderBulkProducts<
  TData = Awaited<ReturnType<typeof getStockOrderBulkProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetStockOrderBulkProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStockOrderBulkProducts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Stock Order Bulk Products
 */

export function useGetStockOrderBulkProducts<
  TData = Awaited<ReturnType<typeof getStockOrderBulkProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetStockOrderBulkProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStockOrderBulkProducts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetStockOrderBulkProductsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get a warehouse order by ID.
 * @summary Get Stock Order
 */
export const getStockOrder = (stockOrderId: string, signal?: AbortSignal) => {
  return customInstance<StockOrderRead>({
    url: `/api/stock_order/${stockOrderId}`,
    method: "GET",
    signal,
  });
};

export const getGetStockOrderQueryKey = (stockOrderId?: string) => {
  return ["api", "stock_order", stockOrderId] as const;
};

export const getGetStockOrderQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockOrder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  stockOrderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStockOrder>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStockOrderQueryKey(stockOrderId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockOrder>>> = ({
    signal,
  }) => getStockOrder(stockOrderId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!stockOrderId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockOrder>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStockOrderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockOrder>>
>;
export type GetStockOrderQueryError = ErrorType<void | HTTPValidationError>;

export function useGetStockOrder<
  TData = Awaited<ReturnType<typeof getStockOrder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  stockOrderId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStockOrder>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockOrder>>,
          TError,
          Awaited<ReturnType<typeof getStockOrder>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStockOrder<
  TData = Awaited<ReturnType<typeof getStockOrder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  stockOrderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStockOrder>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockOrder>>,
          TError,
          Awaited<ReturnType<typeof getStockOrder>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStockOrder<
  TData = Awaited<ReturnType<typeof getStockOrder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  stockOrderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStockOrder>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Stock Order
 */

export function useGetStockOrder<
  TData = Awaited<ReturnType<typeof getStockOrder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  stockOrderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStockOrder>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetStockOrderQueryOptions(stockOrderId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to delete a warehouse order by ID.
 * @summary Delete Stock Order
 */
export const deleteStockOrder = (stockOrderId: string) => {
  return customInstance<unknown>({
    url: `/api/stock_order/${stockOrderId}`,
    method: "DELETE",
  });
};

export const getDeleteStockOrderMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStockOrder>>,
    TError,
    { stockOrderId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteStockOrder>>,
  TError,
  { stockOrderId: string },
  TContext
> => {
  const mutationKey = ["deleteStockOrder"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteStockOrder>>,
    { stockOrderId: string }
  > = (props) => {
    const { stockOrderId } = props ?? {};

    return deleteStockOrder(stockOrderId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteStockOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteStockOrder>>
>;

export type DeleteStockOrderMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Delete Stock Order
 */
export const useDeleteStockOrder = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteStockOrder>>,
      TError,
      { stockOrderId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteStockOrder>>,
  TError,
  { stockOrderId: string },
  TContext
> => {
  const mutationOptions = getDeleteStockOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to update a warehouse order by ID.
 * @summary Update Stock Order
 */
export const updateStockOrder = (
  stockOrderId: string,
  stockOrderCreate: StockOrderCreate,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/stock_order/${stockOrderId}/update`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: stockOrderCreate,
    signal,
  });
};

export const getUpdateStockOrderMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockOrder>>,
    TError,
    { stockOrderId: string; data: StockOrderCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStockOrder>>,
  TError,
  { stockOrderId: string; data: StockOrderCreate },
  TContext
> => {
  const mutationKey = ["updateStockOrder"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStockOrder>>,
    { stockOrderId: string; data: StockOrderCreate }
  > = (props) => {
    const { stockOrderId, data } = props ?? {};

    return updateStockOrder(stockOrderId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStockOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStockOrder>>
>;
export type UpdateStockOrderMutationBody = StockOrderCreate;
export type UpdateStockOrderMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Stock Order
 */
export const useUpdateStockOrder = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateStockOrder>>,
      TError,
      { stockOrderId: string; data: StockOrderCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateStockOrder>>,
  TError,
  { stockOrderId: string; data: StockOrderCreate },
  TContext
> => {
  const mutationOptions = getUpdateStockOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to confirm a warehouse order by ID.
 * @summary Confirm Stock Order
 */
export const confirmStockOrder = (
  stockOrderId: string,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/stock_order/${stockOrderId}/confirm`,
    method: "POST",
    signal,
  });
};

export const getConfirmStockOrderMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmStockOrder>>,
    TError,
    { stockOrderId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmStockOrder>>,
  TError,
  { stockOrderId: string },
  TContext
> => {
  const mutationKey = ["confirmStockOrder"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmStockOrder>>,
    { stockOrderId: string }
  > = (props) => {
    const { stockOrderId } = props ?? {};

    return confirmStockOrder(stockOrderId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmStockOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmStockOrder>>
>;

export type ConfirmStockOrderMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Confirm Stock Order
 */
export const useConfirmStockOrder = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof confirmStockOrder>>,
      TError,
      { stockOrderId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof confirmStockOrder>>,
  TError,
  { stockOrderId: string },
  TContext
> => {
  const mutationOptions = getConfirmStockOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to approve a warehouse order by ID.
 * @summary Approve Stock Order
 */
export const approveStockOrder = (
  stockOrderId: string,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/stock_order/${stockOrderId}/approve`,
    method: "POST",
    signal,
  });
};

export const getApproveStockOrderMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveStockOrder>>,
    TError,
    { stockOrderId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveStockOrder>>,
  TError,
  { stockOrderId: string },
  TContext
> => {
  const mutationKey = ["approveStockOrder"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveStockOrder>>,
    { stockOrderId: string }
  > = (props) => {
    const { stockOrderId } = props ?? {};

    return approveStockOrder(stockOrderId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveStockOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveStockOrder>>
>;

export type ApproveStockOrderMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Approve Stock Order
 */
export const useApproveStockOrder = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof approveStockOrder>>,
      TError,
      { stockOrderId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof approveStockOrder>>,
  TError,
  { stockOrderId: string },
  TContext
> => {
  const mutationOptions = getApproveStockOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to fulfill a warehouse order by ID.
 * @summary Fulfill Stock Order
 */
export const fulfillStockOrder = (
  stockOrderId: string,
  params?: FulfillStockOrderParams,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/stock_order/${stockOrderId}/fulfill`,
    method: "POST",
    params,
    signal,
  });
};

export const getFulfillStockOrderMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof fulfillStockOrder>>,
    TError,
    { stockOrderId: string; params?: FulfillStockOrderParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof fulfillStockOrder>>,
  TError,
  { stockOrderId: string; params?: FulfillStockOrderParams },
  TContext
> => {
  const mutationKey = ["fulfillStockOrder"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof fulfillStockOrder>>,
    { stockOrderId: string; params?: FulfillStockOrderParams }
  > = (props) => {
    const { stockOrderId, params } = props ?? {};

    return fulfillStockOrder(stockOrderId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type FulfillStockOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof fulfillStockOrder>>
>;

export type FulfillStockOrderMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Fulfill Stock Order
 */
export const useFulfillStockOrder = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof fulfillStockOrder>>,
      TError,
      { stockOrderId: string; params?: FulfillStockOrderParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof fulfillStockOrder>>,
  TError,
  { stockOrderId: string; params?: FulfillStockOrderParams },
  TContext
> => {
  const mutationOptions = getFulfillStockOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to cancel a warehouse order by ID.
 * @summary Cancel Stock Order
 */
export const cancelStockOrder = (
  stockOrderId: string,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/stock_order/${stockOrderId}/cancel`,
    method: "POST",
    signal,
  });
};

export const getCancelStockOrderMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelStockOrder>>,
    TError,
    { stockOrderId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelStockOrder>>,
  TError,
  { stockOrderId: string },
  TContext
> => {
  const mutationKey = ["cancelStockOrder"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelStockOrder>>,
    { stockOrderId: string }
  > = (props) => {
    const { stockOrderId } = props ?? {};

    return cancelStockOrder(stockOrderId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelStockOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelStockOrder>>
>;

export type CancelStockOrderMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Cancel Stock Order
 */
export const useCancelStockOrder = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelStockOrder>>,
      TError,
      { stockOrderId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cancelStockOrder>>,
  TError,
  { stockOrderId: string },
  TContext
> => {
  const mutationOptions = getCancelStockOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to update the charged date of a warehouse order by ID.
 * @summary Update Stock Order Charged Date
 */
export const updateStockOrderChargedDate = (
  stockOrderId: string,
  params: UpdateStockOrderChargedDateParams,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/stock_order/${stockOrderId}/set-charged-date`,
    method: "POST",
    params,
    signal,
  });
};

export const getUpdateStockOrderChargedDateMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockOrderChargedDate>>,
    TError,
    { stockOrderId: string; params: UpdateStockOrderChargedDateParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStockOrderChargedDate>>,
  TError,
  { stockOrderId: string; params: UpdateStockOrderChargedDateParams },
  TContext
> => {
  const mutationKey = ["updateStockOrderChargedDate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStockOrderChargedDate>>,
    { stockOrderId: string; params: UpdateStockOrderChargedDateParams }
  > = (props) => {
    const { stockOrderId, params } = props ?? {};

    return updateStockOrderChargedDate(stockOrderId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStockOrderChargedDateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStockOrderChargedDate>>
>;

export type UpdateStockOrderChargedDateMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Stock Order Charged Date
 */
export const useUpdateStockOrderChargedDate = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateStockOrderChargedDate>>,
      TError,
      { stockOrderId: string; params: UpdateStockOrderChargedDateParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateStockOrderChargedDate>>,
  TError,
  { stockOrderId: string; params: UpdateStockOrderChargedDateParams },
  TContext
> => {
  const mutationOptions =
    getUpdateStockOrderChargedDateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to update the target fulfill by date of a warehouse order by ID.
 * @summary Update Stock Order Target Fulfill By
 */
export const updateStockOrderTargetFulfillBy = (
  stockOrderId: string,
  params: UpdateStockOrderTargetFulfillByParams,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/stock_order/${stockOrderId}/set-target-fulfill-by`,
    method: "POST",
    params,
    signal,
  });
};

export const getUpdateStockOrderTargetFulfillByMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStockOrderTargetFulfillBy>>,
    TError,
    { stockOrderId: string; params: UpdateStockOrderTargetFulfillByParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStockOrderTargetFulfillBy>>,
  TError,
  { stockOrderId: string; params: UpdateStockOrderTargetFulfillByParams },
  TContext
> => {
  const mutationKey = ["updateStockOrderTargetFulfillBy"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStockOrderTargetFulfillBy>>,
    { stockOrderId: string; params: UpdateStockOrderTargetFulfillByParams }
  > = (props) => {
    const { stockOrderId, params } = props ?? {};

    return updateStockOrderTargetFulfillBy(stockOrderId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStockOrderTargetFulfillByMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStockOrderTargetFulfillBy>>
>;

export type UpdateStockOrderTargetFulfillByMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Stock Order Target Fulfill By
 */
export const useUpdateStockOrderTargetFulfillBy = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateStockOrderTargetFulfillBy>>,
      TError,
      { stockOrderId: string; params: UpdateStockOrderTargetFulfillByParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateStockOrderTargetFulfillBy>>,
  TError,
  { stockOrderId: string; params: UpdateStockOrderTargetFulfillByParams },
  TContext
> => {
  const mutationOptions =
    getUpdateStockOrderTargetFulfillByMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to create a stock order invoice.
 * @summary Get Stock Order Invoice
 */
export const getStockOrderInvoice = (
  stockOrderId: string,
  signal?: AbortSignal,
) => {
  return customInstance<Blob>({
    url: `/api/stock_order/${stockOrderId}/invoice`,
    method: "GET",
    responseType: "blob",
    signal,
  });
};

export const getGetStockOrderInvoiceQueryKey = (stockOrderId?: string) => {
  return ["api", "stock_order", stockOrderId, "invoice"] as const;
};

export const getGetStockOrderInvoiceQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockOrderInvoice>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  stockOrderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStockOrderInvoice>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStockOrderInvoiceQueryKey(stockOrderId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStockOrderInvoice>>
  > = ({ signal }) => getStockOrderInvoice(stockOrderId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!stockOrderId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockOrderInvoice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStockOrderInvoiceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockOrderInvoice>>
>;
export type GetStockOrderInvoiceQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetStockOrderInvoice<
  TData = Awaited<ReturnType<typeof getStockOrderInvoice>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  stockOrderId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStockOrderInvoice>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockOrderInvoice>>,
          TError,
          Awaited<ReturnType<typeof getStockOrderInvoice>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStockOrderInvoice<
  TData = Awaited<ReturnType<typeof getStockOrderInvoice>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  stockOrderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStockOrderInvoice>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockOrderInvoice>>,
          TError,
          Awaited<ReturnType<typeof getStockOrderInvoice>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStockOrderInvoice<
  TData = Awaited<ReturnType<typeof getStockOrderInvoice>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  stockOrderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStockOrderInvoice>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Stock Order Invoice
 */

export function useGetStockOrderInvoice<
  TData = Awaited<ReturnType<typeof getStockOrderInvoice>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  stockOrderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStockOrderInvoice>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetStockOrderInvoiceQueryOptions(
    stockOrderId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to email a stock order invoice.
 * @summary Email Stock Order Invoice
 */
export const emailStockOrderInvoice = (
  stockOrderId: string,
  emailStockOrderInvoiceBody: string[],
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/stock_order/${stockOrderId}/email-invoice`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: emailStockOrderInvoiceBody,
    signal,
  });
};

export const getEmailStockOrderInvoiceMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof emailStockOrderInvoice>>,
    TError,
    { stockOrderId: string; data: string[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof emailStockOrderInvoice>>,
  TError,
  { stockOrderId: string; data: string[] },
  TContext
> => {
  const mutationKey = ["emailStockOrderInvoice"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof emailStockOrderInvoice>>,
    { stockOrderId: string; data: string[] }
  > = (props) => {
    const { stockOrderId, data } = props ?? {};

    return emailStockOrderInvoice(stockOrderId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmailStockOrderInvoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof emailStockOrderInvoice>>
>;
export type EmailStockOrderInvoiceMutationBody = string[];
export type EmailStockOrderInvoiceMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Email Stock Order Invoice
 */
export const useEmailStockOrderInvoice = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof emailStockOrderInvoice>>,
      TError,
      { stockOrderId: string; data: string[] },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof emailStockOrderInvoice>>,
  TError,
  { stockOrderId: string; data: string[] },
  TContext
> => {
  const mutationOptions = getEmailStockOrderInvoiceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get a PDF packing list for a stock_order by ID.
 * @summary Get Stock Order Packing List
 */
export const getStockOrderPackingList = (
  stockOrderId: string,
  signal?: AbortSignal,
) => {
  return customInstance<Blob>({
    url: `/api/stock_order/${stockOrderId}/packing_list`,
    method: "GET",
    responseType: "blob",
    signal,
  });
};

export const getGetStockOrderPackingListQueryKey = (stockOrderId?: string) => {
  return ["api", "stock_order", stockOrderId, "packing_list"] as const;
};

export const getGetStockOrderPackingListQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockOrderPackingList>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  stockOrderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStockOrderPackingList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStockOrderPackingListQueryKey(stockOrderId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStockOrderPackingList>>
  > = ({ signal }) => getStockOrderPackingList(stockOrderId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!stockOrderId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockOrderPackingList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStockOrderPackingListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockOrderPackingList>>
>;
export type GetStockOrderPackingListQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetStockOrderPackingList<
  TData = Awaited<ReturnType<typeof getStockOrderPackingList>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  stockOrderId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStockOrderPackingList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockOrderPackingList>>,
          TError,
          Awaited<ReturnType<typeof getStockOrderPackingList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStockOrderPackingList<
  TData = Awaited<ReturnType<typeof getStockOrderPackingList>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  stockOrderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStockOrderPackingList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockOrderPackingList>>,
          TError,
          Awaited<ReturnType<typeof getStockOrderPackingList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStockOrderPackingList<
  TData = Awaited<ReturnType<typeof getStockOrderPackingList>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  stockOrderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStockOrderPackingList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Stock Order Packing List
 */

export function useGetStockOrderPackingList<
  TData = Awaited<ReturnType<typeof getStockOrderPackingList>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  stockOrderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStockOrderPackingList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetStockOrderPackingListQueryOptions(
    stockOrderId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
